import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AuthJoin, upload } from "../lib/MyHttp";
import { SearchDevice } from "../lib/Device";
import { SearchId } from "../lib/User";
import moment from "moment";

import CheckidOk from "../popups/checkid_ok";
import CheckidFail from "../popups/checkid_fail";
import JoinOk from "../popups/join_ok";

const years = [];
const month = [];
const days = [];
const nowYYYY = moment().format("YYYY");

for (let i = 1950; i <= nowYYYY; i++) years.push(i);
for (let i = 1; i <= 12; i++) month.push(i);
for (let i = 1; i <= 31; i++) days.push(i);

const MemberJoin = () => {
    const { t } = useTranslation();
    const [searchId, setSearchId] = useState("");
    const [searchDeviceSn, setSearchDeviceSn] = useState("");
    const [showCheckIdOK, setShowCheckIdOK] = useState(false);
    const [showCheckIdFail, setShowCheckIdFail] = useState(false);
    const [showShowJoinOk, setShowJoinOk] = useState(false);

    const [data, setData] = useState({
        id: "",
        pw: "",
        pw2: "",
        name: "",
        sex: "male",
        birth: moment().subtract(40, "year").format("YYYY-MM-DD"),
        email: "",
        phone1: "",
        phone2: "",
        phone3: "",
        inst_nm: "",
        state: "approve",
        type: "user",
        guard_phone1: "",
        guard_phone2: "",
        guard_phone3: "",
        guard_phone: "",
        fb_token: "",
        device_sn: "",
        otp: "",
        otp_dt: "",
        email_otp: "",
        email_dt: "",
        addr1: "",
        addr2: "",
        medical: "",
        agree1: "N",
        agree2: "N",
        push: "Y"
    });

    useEffect(() => {}, []);

    // 중복확인
    const clickSearchId = () => {
        if (data.id === "") return;
        SearchId(data.id, res => {
            if (!res.search) {
                // alert(t("사용가능한 아이디 입니다."));
                setShowCheckIdOK(true);
                setSearchId(data.id);
            } else {
                // alert(t("등록이 불가능한 아이디 입니다."));
                setShowCheckIdFail(true);
                data.id = "";
                setData({ ...data });
            }
        });
    };

    const onChangeFile = async e => {
        const file = e.target.files[0];
        if (file === undefined) return;

        upload(file, file => {
            data.license = file.location;
            setData({ ...data });
        });
    };

    // 회원가입
    const clickJoin = () => {
        if (data.agree1 !== "Y" || data.agree2 !== "Y") {
            alert(t("약관에 동의 해주세요."));
            return;
        }
        if (data.id === "") {
            alert(t("아이디를 확인 해주세요."));
            return;
        }
        if (isSafe && (data.pw === "" || data.pw !== data.pw2)) {
            alert(t("패스워드를 확인 해주세요."));
            return;
        }
        if (data.name === "") {
            alert(t("이름을 확인 해주세요."));
            return;
        }

        if (data.email === "") {
            alert(t("이메일을 확인 해주세요."));
            return;
        }
        if (data.phone1 === "" || data.phone2 === "" || data.phone3 === "") {
            alert(t("연락처를 확인 해주세요."));
            return;
        }

        if (data.guard_phone1 === "" || data.guard_phone2 === "" || data.guard_phone3 === "") {
            alert(t("보호자 연락처를 확인 해주세요."));
            return;
        }

        if (data.push === "N") {
            alert(t("푸쉬알림 설정을 확인 해주세요."));
            return;
        }

        AuthJoin(data, res => {
            setShowJoinOk(true);
            // alert(t("회원가입에 성공하였습니다."));
            // window.location.href = "/";
        });
    };

    const clickSearch = () => {
        SearchDevice(
            data.device_sn,
            res => {
                if (!res.search) {
                    setSearchDeviceSn(data.device_sn);
                    alert(t("등록 가능한 장비 입니다."));
                } else {
                    alert(t("이미 등록한 입니다."));
                    data.device_sn = "";
                    setData({ ...data });
                }
            },
            res => {
                alert(t("등록이 불가능한 장비입니다."));
            }
        );
    };

    const checkPasswordStrength = password => {
        var lowercaseRegex = /[a-z]/;
        var uppercaseRegex = /[A-Z]/;
        var numberRegex = /\d/;
        var specialCharRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

        var hasLowercase = lowercaseRegex.test(password);
        var hasUppercase = uppercaseRegex.test(password);
        var hasNumber = numberRegex.test(password);
        var hasSpecialChar = specialCharRegex.test(password);

        if (hasLowercase && hasUppercase && (hasNumber || hasSpecialChar) && password.length >= 8 && password.length <= 10) {
            return true;
        } else {
            return false;
        }
    };

    const isSafe = checkPasswordStrength(data.pw);
    const disabled = searchId === "" || searchId !== data.id || searchDeviceSn === "" || searchDeviceSn !== data.device_sn;

    return (
        // 회원가입
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("싱글케어 회원 전환")}</h2>
                <h3 className="sub_title_sm">Member Join</h3>

                <div className="tbl_top_box join">
                    <p className="ex">
                        <b>*</b> {t("표기된 항목은 필수 입력 항목입니다.")}
                    </p>
                </div>
                <div className="table_box">
                    <table className="tbl_join">
                        <caption>{t("회원가입")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    <label htmlFor="join_name">
                                        <b>*</b> {t("이름")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="join_name"
                                            value={data.name}
                                            onChange={e => {
                                                data.name = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_birth">
                                        <b>*</b> {t("생년월일")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box birth">
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("YYYY")}
                                            onChange={e => {
                                                data.birth = moment(data.birth).set("year", e.target.value).format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {years.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("년")} </span>
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("M")}
                                            onChange={e => {
                                                data.birth = moment(data.birth)
                                                    .set("month", e.target.value - 1)
                                                    .format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {month.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("월")} </span>
                                        <select
                                            className="select_nor md"
                                            value={moment(data.birth).format("D")}
                                            onChange={e => {
                                                data.birth = moment(data.birth).set("date", e.target.value).format("YYYY-MM-DD");
                                                setData({ ...data });
                                            }}
                                        >
                                            {days.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                        <span>{t("일")} </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_id">
                                        <b>*</b> {t("아이디")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box nowrap">
                                        <input
                                            type="text"
                                            className="text_nor md grow"
                                            id="join_id"
                                            value={data.id}
                                            onChange={e => {
                                                data.id = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <button type="button" className="btn_nor md line z-sh" onClick={clickSearchId}>
                                            {t("중복확인")}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_pwd">
                                        <b>*</b> {t("비밀번호")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="password"
                                            className="text_nor md"
                                            id="join_pwd"
                                            value={data.pw}
                                            onChange={e => {
                                                data.pw = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        {isSafe && <p className="join_alert_text yellow">{t("안전합니다.")}</p>}
                                    </div>
                                    <p className="explain">※ {t("영문 대소문자, 숫자, 특수문자 중 2가지 이상 조합하여 설정해주세요. (8~10자리)")}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_pwd2">
                                        <b>*</b> {t("비밀번호 확인")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="password"
                                            className={data.pw !== data.pw2 && data.pw2 !== "" ? "text_nor md alt" : "text_nor md"}
                                            id="join_pwd2"
                                            value={data.pw2}
                                            onChange={e => {
                                                data.pw2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        {data.pw !== data.pw2 && data.pw2 !== "" && <p className="join_alert_text gray">{t("비밀번호가 일치하지 않습니다.")}</p>}
                                    </div>
                                    {/* {data.pw !== data.pw2 && data.pw2 !== "" && <p className="explain red">※ {t("비밀번호를 다시 한번 확인해 주시기 바랍니다.")}</p>} */}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>
                                        <b>*</b> {t("휴대전화 번호")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone1}
                                            onChange={e => {
                                                data.phone1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone2}
                                            onChange={e => {
                                                data.phone2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.phone3}
                                            onChange={e => {
                                                data.phone3 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_email">
                                        <b>*</b> {t("이메일")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md em_01"
                                            id="join_email"
                                            value={data.email.split("@")[0]}
                                            onChange={e => {
                                                data.email = e.target.value + "@" + (data.email.split("@")[1] || "");
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>@</span>
                                        <input
                                            type="text"
                                            className="text_nor md em_02"
                                            value={data.email.split("@")[1]}
                                            onChange={e => {
                                                data.email = data.email.split("@")[0] + "@" + e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <select className="select_nor md">
                                            <option value="">{t("직접입력")}</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_device">
                                        <b>*</b> {t("기기등록")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="join_device"
                                            value={data.device_sn}
                                            onChange={e => {
                                                data.device_sn = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <button type="button" className="btn_nor md line" onClick={clickSearch}>
                                            {t("검색")}
                                        </button>
                                    </div>
                                    <p className="explain">※ {t("소유하고 계신 기기의 시리얼 번호를 등록하시면 현재 기기의 상태와 생체 정보를 확인하실 수 있습니다.")}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label htmlFor="join_addr">
                                        <b>*</b> {t("주소")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        {/* <input type="text" className="text_nor md addr" id="join_addr" /> */}
                                        <input
                                            type="text"
                                            className="text_nor md w100"
                                            value={data.addr1}
                                            onChange={e => {
                                                data.addr1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="text_nor md w100"
                                            placeholder={t("상세주소를 입력하세요")}
                                            value={data.addr2}
                                            onChange={e => {
                                                data.addr2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                    <p className="explain">※ {t("소유하고 계신 기기의 시리얼 번호를 등록하시면 현재 기기의 상태와 생체 정보를 확인하실 수 있습니다.")}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="tbl_top_box join">
                    <h4 className="tit">{t("추가정보 입력")}</h4>
                </div>
                <div className="table_box">
                    <table className="tbl_join">
                        <caption>{t("회원가입")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    <label htmlFor="join_disease">
                                        <b>*</b> {t("병력 및 질환등록")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="text"
                                            className="text_nor md"
                                            id="join_disease"
                                            value={data.medical}
                                            onChange={e => {
                                                data.medical = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        {/* <button type="button" className="btn_nor md line">
                                            중복확인
                                        </button> */}
                                    </div>
                                </td>
                            </tr>
                            {/* <tr>
                                <th>
                                    <label htmlFor="join_partner">
                                        <b>*</b> {t("보호자")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input type="text" className="text_nor md" id="join_partner" />
                                    </div>
                                </td>
                            </tr> */}
                            <tr>
                                <th>
                                    <label>
                                        <b>*</b> {t("보호자 연락처")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.guard_phone1}
                                            onChange={e => {
                                                data.guard_phone1 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.guard_phone2}
                                            onChange={e => {
                                                data.guard_phone2 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                        <span>-</span>
                                        <input
                                            type="number"
                                            className="text_nor md phone"
                                            maxLength={4}
                                            value={data.guard_phone3}
                                            onChange={e => {
                                                data.guard_phone3 = e.target.value;
                                                setData({ ...data });
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>
                                        <b>*</b> {t("푸쉬알림 설정")}
                                    </label>
                                </th>
                                <td>
                                    <div className="form-box gap-lg text">
                                        <span>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="push"
                                                    className="radio1"
                                                    checked={data.push === "Y"}
                                                    onClick={() => {
                                                        data.push = "Y";
                                                        setData({ ...data });
                                                    }}
                                                />{" "}
                                                {t("알림수신")}
                                            </label>
                                        </span>
                                        <span>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="push"
                                                    className="radio1"
                                                    checked={data.push !== "Y"}
                                                    onClick={() => {
                                                        data.push = "N";
                                                        setData({ ...data });
                                                    }}
                                                />{" "}
                                                {t("알림수신 거부")}
                                            </label>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="tbl_top_box join">
                    <h4 className="tit">{t("약관 동의 안내")}</h4>
                </div>
                <div className="table_box">
                    <table className="tbl_join">
                        <caption>{t("회원가입")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    <label>
                                        <b>*</b> {t("약관 동의")}
                                    </label>
                                </th>
                                <td>
                                    <p className="confirm_row">
                                        <span className="check">
                                            <input
                                                type="checkbox"
                                                id="join_check"
                                                onClick={() => {
                                                    if (data.agree1 === "Y" && data.agree2 === "Y") {
                                                        data.agree1 = "N";
                                                        data.agree2 = "N";
                                                    } else {
                                                        data.agree1 = "Y";
                                                        data.agree2 = "Y";
                                                    }
                                                    setData({ ...data });
                                                }}
                                                checked={data.agree1 === "Y" && data.agree2 === "Y"}
                                            />
                                            <label htmlFor="join_check">{t("전체 약관 동의")}</label>
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th className="blank"></th>
                                <td>
                                    <p className="confirm_row">
                                        <span className="check">
                                            <input
                                                type="checkbox"
                                                id="join_check2"
                                                onClick={() => {
                                                    data.agree1 = data.agree1 === "Y" ? "N" : "Y";
                                                    setData({ ...data });
                                                }}
                                                checked={data.agree1 === "Y"}
                                            />
                                            <label htmlFor="join_check2">
                                                [{t("필수")}] {t("서비스 이용 약관")}
                                            </label>
                                        </span>
                                        <a href="#" className="link">
                                            {t("내용보기")}
                                        </a>
                                    </p>
                                    <p className="confirm_row">
                                        <span className="check">
                                            <input
                                                type="checkbox"
                                                id="join_check3"
                                                onClick={() => {
                                                    data.agree2 = data.agree2 === "Y" ? "N" : "Y";
                                                    setData({ ...data });
                                                }}
                                                checked={data.agree2 === "Y"}
                                            />
                                            <label htmlFor="join_check3">
                                                [{t("필수")}] {t("개인정보 수집 이용 동의")}
                                            </label>
                                        </span>
                                        <a href="#" className="link">
                                            {t("내용보기")}
                                        </a>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="btn_bott_box">
                    <a href="/" className="btn_nor line minW">
                        {t("돌아가기")}
                    </a>
                    <a href="javascript:;" className="btn_nor orange minW" onClick={clickJoin} disabled={disabled}>
                        {t("회원가입")}
                    </a>
                </div>
            </div>

            {showCheckIdOK && (
                <CheckidOk
                    onClose={() => {
                        setShowCheckIdOK(false);
                    }}
                />
            )}
            {showCheckIdFail && (
                <CheckidFail
                    onClose={() => {
                        setShowCheckIdFail(false);
                    }}
                />
            )}
            {showShowJoinOk && (
                <JoinOk
                    onClose={() => {
                        setShowJoinOk(false);
                        window.location.href = "/";
                    }}
                />
            )}
        </main>
    );
};

export default MemberJoin;
